<template>
  <div class="fixed-header menu-pin"
       id="#app">
    <svg width="0" height="0" class="hidden">
      <symbol id="hint-circle" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 64 64">
        <g>
          <g>
            <path d="M32.331,46.326c-1.753,0-3.278-0.711-4.32-2.024c-0.971-1.222-1.384-2.833-1.135-4.421l1.196-7.618    l-0.276,0.142c-1.383,0.711-3.081,0.166-3.792-1.217c-0.711-1.383-0.166-3.081,1.217-3.792l5.205-2.676    c0.943-0.485,2.078-0.399,2.937,0.222c0.859,0.621,1.297,1.672,1.132,2.719L32.45,40.685c0.41-0.043,1.467-0.301,3.435-1.668    c1.277-0.888,3.032-0.572,3.919,0.705c0.888,1.277,0.572,3.032-0.705,3.919c-2.459,1.71-4.568,2.585-6.446,2.677    C32.545,46.324,32.437,46.326,32.331,46.326z"></path>
          </g>
          <g>
            <circle cx="32.803" cy="19.233" r="3.143"></circle>
          </g>
          <g>
            <g>
              <path d="M32,59.5C16.836,59.5,4.5,47.164,4.5,32S16.836,4.5,32,4.5S59.5,16.837,59.5,32     S47.163,59.5,32,59.5z M32,10.132c-12.058,0-21.868,9.81-21.868,21.868S19.942,53.868,32,53.868     c12.058,0,21.868-9.81,21.868-21.868S44.058,10.132,32,10.132z"></path>
            </g>
          </g>
        </g>
      </symbol>
      <symbol version="1.1" id="in-progress-circle-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 100 100">
        <path d="M49.6,1C22.5,1,0.5,23,0.5,50.1s22,49.1,49.1,49.1s49.1-22,49.1-49.1S76.8,1,49.6,1z M49.6,93.3C25.8,93.3,6.5,74,6.5,50.1
        S25.8,7,49.6,7s43.1,19.3,43.1,43.1S73.5,93.3,49.6,93.3z"></path>
        <path d="M51.9,25.9c-0.6-0.6-1.4-0.9-2.2-0.9s-1.6,0.3-2.2,0.9L31.7,41.6l0,0c-0.8,0.8-1.1,2-0.8,3c0.3,1.1,1.1,1.9,2.2,2.2
        c1.1,0.3,2.3,0,3-0.8l10.3-10.4v36.4c0,1.1,0.6,2.2,1.6,2.7c1,0.6,2.2,0.6,3.1,0c1-0.6,1.6-1.6,1.6-2.7V35.7l10.3,10.4l0,0
        c0.8,0.8,2,1.1,3,0.8c1.1-0.3,1.9-1.1,2.2-2.2c0.3-1.1,0-2.3-0.8-3L51.9,25.9z"></path>
      </symbol>
      <symbol version="1.1" id="pending-circle-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 50 50">
        <path d="M20,13.4c0.3,0.2,0.7,0.3,1.1,0.2c0.4-0.1,0.7-0.3,0.9-0.6l5.2-7.3l-1-0.7l0,0c-0.2-0.2-0.4-0.3-0.6-0.4
        l-5.8-4.1l0,0c-0.3-0.2-0.7-0.3-1.1-0.2c-0.4,0.1-0.7,0.3-0.9,0.6c-0.2,0.3-0.3,0.7-0.2,1.1c0.1,0.4,0.3,0.7,0.6,0.9l3,2.1
        c-5.6,1-10.5,4-14,8.5C3.7,18,2.1,23.6,2.6,29.2c0.5,5.6,3.1,10.9,7.2,14.7s9.6,5.9,15.2,5.9c0.5,0,1-0.3,1.2-0.7
        c0.3-0.4,0.3-1,0-1.4C26,47.2,25.6,47,25.1,47c-5,0-9.8-1.9-13.5-5.3c-3.7-3.4-5.9-8.1-6.2-13.1c-0.4-5,1.2-9.9,4.3-13.8
        c3.1-3.9,7.6-6.4,12.6-7.1l-2.7,3.8v0c-0.2,0.3-0.3,0.7-0.2,1.1C19.5,12.9,19.7,13.2,20,13.4L20,13.4z"></path>
        <path d="M37.1,42.8c-1.9,1.4-4,2.5-6.2,3.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.1,0,0.3,0.1,0.4
        c0.1,0.3,0.3,0.5,0.5,0.7c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.3,0,0.4-0.1v0l0,0c0,0,0,0,0,0h0c2.5-0.8,4.9-2,7-3.6
        c0.3-0.2,0.5-0.6,0.5-0.9c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.6-0.5-0.9-0.5C37.7,42.5,37.4,42.6,37.1,42.8L37.1,42.8z"></path>
        <path d="M44.6,24.2c0.1,0.3,0.2,0.6,0.5,0.9c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.1,0,0.2,0c0.3-0.1,0.6-0.2,0.9-0.5
        c0.2-0.3,0.3-0.6,0.3-0.9c0-0.1,0-0.1,0-0.2c-0.4-2.7-1.3-5.2-2.6-7.6c-0.2-0.4-0.6-0.6-1-0.7c-0.4-0.1-0.8,0-1.2,0.3
        c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.2,0.1,0.5,0.2,0.7C43.5,19.7,44.2,21.9,44.6,24.2L44.6,24.2z"></path>
        <path d="M32.9,6c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.5,0.7C31,7,31,7.2,31,7.3
        c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.4,0.7,0.5c2.2,0.8,4.2,2,6,3.5l0,0c0,0,0,0,0,0l0,0c0.3,0.2,0.6,0.3,0.9,0.3
        c0.4,0,0.8-0.2,1.1-0.5c0.2-0.3,0.3-0.6,0.3-0.9c0-0.4-0.2-0.8-0.5-1.1C37.8,8.3,35.4,6.9,32.9,6L32.9,6z"></path>
        <path d="M46.1,30.1c-0.4-0.1-0.7,0-1.1,0.2c-0.3,0.2-0.5,0.5-0.6,0.9c-0.5,2.3-1.4,4.5-2.6,6.5
        c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.4,1.1,0.3c0.4-0.1,0.8-0.3,1-0.6c1.4-2.3,2.4-4.8,3-7.4
        c0.1-0.4,0-0.7-0.2-1.1C46.7,30.4,46.4,30.2,46.1,30.1L46.1,30.1z"></path>
      </symbol>
      <symbol version="1.1" id="pending-validation-circle-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 50 50">
        <path d="M20,13.4c0.3,0.2,0.7,0.3,1.1,0.2c0.4-0.1,0.7-0.3,0.9-0.6l5.2-7.3l-1-0.7l0,0c-0.2-0.2-0.4-0.3-0.6-0.4
        l-5.8-4.1l0,0c-0.3-0.2-0.7-0.3-1.1-0.2c-0.4,0.1-0.7,0.3-0.9,0.6c-0.2,0.3-0.3,0.7-0.2,1.1c0.1,0.4,0.3,0.7,0.6,0.9l3,2.1
        c-5.6,1-10.5,4-14,8.5C3.7,18,2.1,23.6,2.6,29.2c0.5,5.6,3.1,10.9,7.2,14.7s9.6,5.9,15.2,5.9c0.5,0,1-0.3,1.2-0.7
        c0.3-0.4,0.3-1,0-1.4C26,47.2,25.6,47,25.1,47c-5,0-9.8-1.9-13.5-5.3c-3.7-3.4-5.9-8.1-6.2-13.1c-0.4-5,1.2-9.9,4.3-13.8
        c3.1-3.9,7.6-6.4,12.6-7.1l-2.7,3.8v0c-0.2,0.3-0.3,0.7-0.2,1.1C19.5,12.9,19.7,13.2,20,13.4L20,13.4z"></path>
        <path d="M37.1,42.8c-1.9,1.4-4,2.5-6.2,3.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.1,0,0.3,0.1,0.4
        c0.1,0.3,0.3,0.5,0.5,0.7c0.2,0.2,0.5,0.3,0.8,0.3c0.1,0,0.3,0,0.4-0.1v0l0,0c0,0,0,0,0,0h0c2.5-0.8,4.9-2,7-3.6
        c0.3-0.2,0.5-0.6,0.5-0.9c0-0.4-0.1-0.7-0.3-1c-0.2-0.3-0.6-0.5-0.9-0.5C37.7,42.5,37.4,42.6,37.1,42.8L37.1,42.8z"></path>
        <path d="M44.6,24.2c0.1,0.3,0.2,0.6,0.5,0.9c0.3,0.2,0.6,0.3,0.9,0.3c0.1,0,0.1,0,0.2,0c0.3-0.1,0.6-0.2,0.9-0.5
        c0.2-0.3,0.3-0.6,0.3-0.9c0-0.1,0-0.1,0-0.2c-0.4-2.7-1.3-5.2-2.6-7.6c-0.2-0.4-0.6-0.6-1-0.7c-0.4-0.1-0.8,0-1.2,0.3
        c-0.3,0.3-0.5,0.7-0.5,1.1c0,0.2,0.1,0.5,0.2,0.7C43.5,19.7,44.2,21.9,44.6,24.2L44.6,24.2z"></path>
        <path d="M32.9,6c-0.2-0.1-0.3-0.1-0.5-0.1c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.5,0.7C31,7,31,7.2,31,7.3
        c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.4,0.4,0.7,0.5c2.2,0.8,4.2,2,6,3.5l0,0c0,0,0,0,0,0l0,0c0.3,0.2,0.6,0.3,0.9,0.3
        c0.4,0,0.8-0.2,1.1-0.5c0.2-0.3,0.3-0.6,0.3-0.9c0-0.4-0.2-0.8-0.5-1.1C37.8,8.3,35.4,6.9,32.9,6L32.9,6z"></path>
        <path d="M46.1,30.1c-0.4-0.1-0.7,0-1.1,0.2c-0.3,0.2-0.5,0.5-0.6,0.9c-0.5,2.3-1.4,4.5-2.6,6.5
        c-0.1,0.2-0.2,0.5-0.2,0.8c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.4,1.1,0.3c0.4-0.1,0.8-0.3,1-0.6c1.4-2.3,2.4-4.8,3-7.4
        c0.1-0.4,0-0.7-0.2-1.1C46.7,30.4,46.4,30.2,46.1,30.1L46.1,30.1z"></path>
      </symbol>
      <symbol version="1.1" id="validated-circle-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" xml:space="preserve" viewBox="0 0 50 50">
        <g>
          <path d="M42.6,7.5c-4.7-4.7-10.9-7.2-17.5-7.2S12.2,2.8,7.6,7.5C2.9,12.2,0.3,18.4,0.3,25s2.6,12.8,7.2,17.5
          c4.7,4.7,10.9,7.2,17.5,7.2s12.8-2.6,17.5-7.2c4.7-4.7,7.2-10.9,7.2-17.5S47.2,12.2,42.6,7.5z M40.5,40.4
          c-4.1,4.1-9.6,6.4-15.4,6.4s-11.3-2.3-15.4-6.4C5.5,36.3,3.2,30.8,3.2,25c0-5.8,2.3-11.3,6.4-15.4c4.1-4.1,9.6-6.4,15.4-6.4
          s11.3,2.3,15.4,6.4c4.1,4.1,6.4,9.6,6.4,15.4C46.9,30.8,44.6,36.3,40.5,40.4z"></path>
          <path d="M35.5,16.5c-1.6,1.6-3.1,3.2-4.7,4.9c-2.5,2.6-4.9,5.1-7.4,7.7c-0.2,0.2-0.4,0.4-0.5,0.6
          c-2-1.8-4.1-3.7-6.1-5.5c-0.4-0.3-0.7-0.6-1.1-1c-0.7-0.6-1.8-0.7-2.5,0c-0.6,0.7-0.7,1.8,0,2.5c2.5,2.2,4.9,4.5,7.4,6.7
          c0.4,0.3,0.7,0.6,1.1,1c0.7,0.6,1.8,0.7,2.5,0c1.6-1.6,3.1-3.2,4.7-4.9c2.5-2.6,4.9-5.1,7.4-7.7c0.6-0.6,1.1-1.2,1.7-1.8
          c0.6-0.7,0.7-1.8,0-2.5C37.3,15.8,36.2,15.7,35.5,16.5z"></path>
        </g>
      </symbol>
    </svg>
    <sidebar></sidebar>
    <!-- START PAGE-CONTAINER -->
    <div class="page-container">
      <page-header></page-header>
      <div class="page-content-wrapper">
        <!-- START PAGE CONTENT -->
        <div class="content">
          <!-- <jumbotron></jumbotron> -->
          <!-- <div class="container-fluid container-fixed-lg"> -->
          <div class="container-fluid">
            <!-- BEGIN PlACE PAGE CONTENT HERE -->
            <router-view></router-view>
            <!-- END PLACE PAGE CONTENT HERE -->
          </div>
        </div>
        <!-- END PAGE CONTENT -->
        <page-footer></page-footer>
      </div>
      <!-- END PAGE CONTENT WRAPPER -->
    </div>
    <!-- END PAGE CONTAINER -->
    <search-overlay></search-overlay>
  </div>
</template>

<script type="text/babel">
  import Sidebar from './Sidebar/Sidebar'
  import PageHeader from './Header/Header'
  import PageFooter from './Footer'
  import Jumbotron from './Jumbotron'
  import SearchOverlay from './SearchOverlay/SearchOverlay'

  const sidebarCb = function () {
    const width = $(window).width(),
      classNames = 'menu-pin sidebar-visible',
      $body = $('body'),
      hasClasses = classNames.split(' ')
        .reduce((className) => $body.hasClass(className))

    if (width <= 991 && width >= 980) {
      hasClasses && $body.removeClass(classNames)
    } else {
      !hasClasses && $body.addClass(classNames)
    }

  }

  export default {
    components: {
      Sidebar,
      PageHeader,
      Jumbotron,
      PageFooter,
      SearchOverlay
    },

    mounted () {
      $.Pages.init()
      sidebarCb()
      $(window).resize(_.throttle(sidebarCb, 16))
    }
  }
</script>

<style>
  .container-fluid {
    padding-right: 15px;
  }
  .page-container .page-content-wrapper .content {
    min-height: 100vh;
    padding-bottom: 70px;
  }

  .pgn-bar .alert > div > div.pgn-message > div {
      height: auto !important;
      word-break: normal;
  }
  .pgn-bar .alert {
      height: auto !important;
      margin: 0 0 20px;
      border-radius: 0;
  }
  .pgn-bar .alert span {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// client/components/AppLayout.vue